import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_document_hdr_attachment_flow_RowClass,
} from '../../../dbschema';

export class MyClaimDocumentHdrAttachmentFlowContainerModel extends BaseContainerModel {
  bl_aat_claim_document_hdr_attachment_flow: bl_aat_claim_document_hdr_attachment_flow_RowClass = new bl_aat_claim_document_hdr_attachment_flow_RowClass();
}
